import { useCallback, useEffect, useState } from "preact/hooks";
export function useResource(load, deps = []) {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [nonce, setNonce] = useState(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- the caller states its own deps
    const run = useCallback(load, deps);
    useEffect(() => {
        const controller = new AbortController();
        let cancelled = false;
        setLoading(true);
        void run(controller.signal)
            .then((value) => {
            if (cancelled)
                return;
            setData(value);
            setError(null);
        })
            .catch((cause) => {
            // An abort is this component going away, not a failure to report.
            if (cancelled || controller.signal.aborted)
                return;
            setError(cause instanceof Error ? cause : new Error(String(cause)));
        })
            .finally(() => {
            if (!cancelled)
                setLoading(false);
        });
        return () => {
            cancelled = true;
            controller.abort();
        };
    }, [run, nonce]);
    const reload = useCallback(() => {
        setNonce((value) => value + 1);
    }, []);
    return { data, error, loading, reload };
}
//# sourceMappingURL=use-resource.js.map